/** Text cleaning shared by the dashboard and the engine's lookups. */
/** Text as the engine keeps it: invisible format characters (macOS puts
 * one before some app names; titles can carry direction marks) taken out,
 * and the ends trimmed. The same characters as zunox_basic.record.clean. */
// One alternation per character (a character class with a joiner in it is
// read as a joined sequence).
const INVISIBLE = /\u200b|\u200c|\u200d|\u200e|\u200f|\u2060|\ufeff/g;
// Python's strip() also takes the information separators and NEL off the
// ends, which JavaScript's trim() leaves.
// eslint-disable-next-line no-control-regex
const ENDS = /^[\s\x1c-\x1f\x85]+|[\s\x1c-\x1f\x85]+$/g;
export function cleanText(text) {
    return String(text ?? '')
        .replace(INVISIBLE, '')
        .replace(ENDS, '');
}
